import AttributeLookupModelBase from '../_generated/modelBases/attribute-lookup-model-base';

export default class AttributeLookupModel extends AttributeLookupModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
